export default __webpack_public_path__ + "static/media/fullsizeoutput_806.95bb88ea.png";